import React from "react";
import { useApp } from "../context/AppContext";

const LanguageToggle = ({ className = "" }) => {
  const { language, setLanguage } = useApp();
  return (
    <div
      className={`flex items-center gap-1 text-xs tracking-luxury uppercase ${className}`}
      data-testid="language-toggle"
    >
      <button
        type="button"
        onClick={() => setLanguage("es")}
        className={`px-3 py-2 transition-opacity ${
          language === "es" ? "opacity-100" : "opacity-50 hover:opacity-80"
        }`}
        data-testid="lang-btn-es"
      >
        ES
      </button>
      <span className="opacity-30">/</span>
      <button
        type="button"
        onClick={() => setLanguage("en")}
        className={`px-3 py-2 transition-opacity ${
          language === "en" ? "opacity-100" : "opacity-50 hover:opacity-80"
        }`}
        data-testid="lang-btn-en"
      >
        EN
      </button>
    </div>
  );
};

export default LanguageToggle;
